<div class="ui-info-box" [ngClass]="status">
  <span [ngClass]="getIcon()"></span>
  <div class="ui-info-box-content">
    <ng-content></ng-content>
  </div>
</div>
